import { camelCase, startCase } from 'lodash';

import { ForbearanceWorkoutPlan, WorkoutPlanStatus, WorkoutPlanType } from '@willow/graphql-iso/src/app';
import { LoanReportingWorkoutPlanType } from '@willow/types-iso';

import { assertNever } from './assertNever';

export const formatWorkoutPlanType = (type: WorkoutPlanType) => {
  switch (type) {
    case WorkoutPlanType.PaymentDeferment:
      return 'Payment Deferment';
    case WorkoutPlanType.PaymentDeferral:
      return 'Payment Deferral';
    case WorkoutPlanType.Forbearance:
      return 'Forbearance';
    case WorkoutPlanType.FlexModification:
      return 'Flex Modification Trial';
    case WorkoutPlanType.RepaymentPlan:
      return 'Repayment Plan';
    default:
      assertNever(type);
  }
};

export const formatWorkoutPlanTypeShort = (type: WorkoutPlanType) => {
  switch (type) {
    case WorkoutPlanType.PaymentDeferment:
      return 'Deferment';
    case WorkoutPlanType.PaymentDeferral:
      return 'Deferral';
    case WorkoutPlanType.Forbearance:
      return 'Forbearance';
    case WorkoutPlanType.FlexModification:
      return 'Flex Modification';
    case WorkoutPlanType.RepaymentPlan:
      return 'Repayment Plan';
    default:
      assertNever(type);
  }
};

/** Accepts any workout plan with a type field (e.g. GraphQL fragments or types-iso plans). */
export const getWorkoutPlanTypeLabel = (
  plan: { type: WorkoutPlanType } & Partial<Pick<ForbearanceWorkoutPlan, 'forbearanceType'>>,
  isShort: boolean,
) => {
  switch (plan.type) {
    case WorkoutPlanType.Forbearance:
      return `${startCase(camelCase((plan as ForbearanceWorkoutPlan).forbearanceType))} Forbearance`;
    case WorkoutPlanType.PaymentDeferment:
    case WorkoutPlanType.PaymentDeferral:
    case WorkoutPlanType.FlexModification:
    case WorkoutPlanType.RepaymentPlan:
      return isShort ? formatWorkoutPlanTypeShort(plan.type) : formatWorkoutPlanType(plan.type);
    default:
      assertNever(plan.type);
  }
};

export const formatLoanReportingWorkoutPlanType = (type: LoanReportingWorkoutPlanType) => {
  switch (type) {
    case LoanReportingWorkoutPlanType.enum.PAYMENT_DEFERMENT:
      return 'Payment Deferment';
    case LoanReportingWorkoutPlanType.enum.PAYMENT_DEFERRAL:
      return 'Payment Deferral';
    case LoanReportingWorkoutPlanType.enum.FLEX_MODIFICATION:
      return 'Flex Modification Trial';
    case LoanReportingWorkoutPlanType.enum.FORBEARANCE:
      return 'Forbearance';
    case LoanReportingWorkoutPlanType.enum.REPAYMENT_PLAN:
      return 'Repayment Plan';
    case LoanReportingWorkoutPlanType.enum.NONE:
      return 'None';
    default:
      assertNever(type);
  }
};

export const formatWorkoutPlanStatusLabel = (status: WorkoutPlanStatus) => {
  return startCase(camelCase(status));
};
